/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCheckoutSessionDto } from '../../models/create-checkout-session-dto';
import { ResponseCheckoutSessionDto } from '../../models/response-checkout-session-dto';

export interface CheckoutSessionsControllerCreateCheckoutSession$Params {
      body: CreateCheckoutSessionDto
}

export function checkoutSessionsControllerCreateCheckoutSession(http: HttpClient, rootUrl: string, params: CheckoutSessionsControllerCreateCheckoutSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseCheckoutSessionDto>> {
  const rb = new RequestBuilder(rootUrl, checkoutSessionsControllerCreateCheckoutSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseCheckoutSessionDto>;
    })
  );
}

checkoutSessionsControllerCreateCheckoutSession.PATH = '/keus-payments/checkout-sessions';
